<template>
    <!-- 申请退货页面 -->
    <div class="return-wrapper">
        <div class="liquid-wrapper-outer">
            <div class="liquid-wrapper">
                <div class="each-title-wrapper">
                    <img
                        :src="submitApplicationSrc"
                        alt="submit-application.png"
                    />
                    <span>提交申请</span>
                </div>
                <div class="empty-border"></div>
                <div class="each-title-wrapper">
                    <img :src="serviceReviewSrc" alt="service-review.png" />
                    <span>客服审核</span>
                </div>
                <div class="empty-border"></div>
                <div class="each-title-wrapper">
                    <img :src="buyerPickUpSrc" alt="buyer-pick-up.png" />
                    <span>买家提货</span>
                </div>
                <div class="empty-border"></div>
                <div class="each-title-wrapper">
                    <img :src="returnGoodsSrc" alt="return-goods.png" />
                    <span>退货</span>
                </div>
            </div>
            <div class="order-number">
                <span class="order-title">订单号</span>
                <span class="order-num">{{ data.orderNo }}</span>
            </div>
        </div>
        <div class="order-card" v-cloak>
            <div class="goods-preview">
                <div class="detail-wra">
                    <div class="row1">{{ data.productName }}</div>
                    <div class="row2" v-if="data.specName">
                        <span>产品规格</span>
                        <span class="mr25">{{ data.specName }}</span>
                    </div>
                    <div class="row3">
                        <span class="buy-title">购买数量</span>
                        <span class="buy-number">
                            <span>￥</span>
                            {{ data.factFee }}
                            <span class="multiplication">x</span>
                            {{ data.quantity }}份
                        </span>
                    </div>
                </div>
            </div>
            <div class="each-block">
                <div class="each-row mb25">
                    <div class="left">退款原因</div>
                </div>
                <van-radio-group v-model="reason" v-cloak class="radios">
                    <van-radio
                        checked-color="#f0bb1b"
                        shape="square"
                        v-for="(item, index) in reasonArr"
                        :key="index"
                        :name="+index + 1"
                        >{{ item }}</van-radio
                    >
                </van-radio-group>
                <div class="reason-textarea-warapper">
                    <van-field
                        v-model="reasonText"
                        v-if="reason == 5"
                        class="reason-textarea"
                        type="textarea"
                        placeholder="请输入原因"
                        rows="5"
                    />
                    <div class="text-length">{{ reasonTextLength }}/50</div>
                </div>
                <div
                    class="submit-btn iphonex-adapt-margin"
                    @click.stop="submit"
                >
                    <img
                        v-if="isCostLoading"
                        :src="loadingSrc"
                        class="loading"
                    />
                    <span v-else>申请退货</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EXPRESS from "@/js/express_code";
export default {
    name: "ApplyForReturn",
    components: {},
    props: {},
    data() {
        return {
            liNumber: "", //物流单号
            columns: EXPRESS.map((e) => e.company),
            liCompany: "",
            liCompanyCode: "",
            data: {},
            isCostLoading: false,
            reason: 1, //radio原因类型
            reasonArr: [
                "商品有瑕疵",
                "买错了",
                "不喜欢了",
                "商品发错",
                "其他原因",
            ],
            returnLiquidSrc: "",
            rightIconSrc: "",
            reasonText: "",
            loadingSrc: "",
            submitApplicationSrc: "",
            serviceReviewSrc: "",
            buyerPickUpSrc: "",
            returnGoodsSrc: "",
        };
    },
    computed: {
        reasonTextLength() {
            return this.reasonText.length;
        },
    },
    watch: {},
    created() {
        if (sessionStorage.returnData) {
            this.data = JSON.parse(sessionStorage.returnData);
        }
    },
    mounted() {
        this.loadingSrc = API.ossUrl + "common/loading.svg";
        this.submitApplicationSrc =
            API.ossUrl + "order/png/submit-application.png";
        this.serviceReviewSrc = API.ossUrl + "order/png/service-review.png";
        this.buyerPickUpSrc = API.ossUrl + "order/png/buyer-pick-up.png";
        this.returnGoodsSrc = API.ossUrl + "order/png/return-goods.png";
    },
    destroyed() {},
    methods: {
        submit() {
            if (this.reason == 5) {
                if (this.reasonText.trim() === "") {
                    this.$alert("原因不能为空哦");
                    return false;
                }
                if (this.reasonText.length > 50) {
                    this.$alert("原因不能超过50个字！");
                    return false;
                }
            }
            this.putReturn();
        },
        putReturn() {
            if (this.isCostLoading) return;
            this.isCostLoading = true;
            let body = {
                reasonCode: this.reason,
                reasonBody: this.reason == 5 ? this.reasonText : "",
            };
            this.$axios
                .put(
                    `${window.API.order.changeOrderStatus}/${this.data.id}?token=${sessionStorage.token}`,
                    body
                )
                .then(({ data }) => {
                    this.isCostLoading = false;
                    if (data.code == 200) {
                        this.$toast("申请退货成功,请等待客服审核");
                        this.$router.go(-1);
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        getDurationDay(s, e) {
            const range = moment.range(s, e);
            const days = range.diff("day");
            return days;
        },
    },
};
</script>
<style scoped lang="scss">
.li-btn {
    position: absolute;
    right: 0px;
    bottom: 19px;
    font-size: 12px;
    color: $blue;
}
.return-wrapper {
    min-height: 100%;
    padding: 0.32rem 0.533333rem 0.373333rem;
    .liquid-wrapper-outer {
        margin: 0 auto;
        background: $white;
        padding: 0.32rem 0.373333rem 0.346667rem;
        box-shadow: 0px 2px 5px 1px rgba(228, 228, 228, 0.46);
        border-radius: 0.16rem;
        .liquid-wrapper {
            display: flex;
            .each-title-wrapper {
                width: 1.493333rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                img {
                    width: 0.8rem;
                    height: 0.8rem;
                    margin-bottom: 0.32rem;
                    display: block;
                }
                span {
                    width: 1.493333rem;
                    text-align: center;
                    font-size: 0.373333rem;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    color: #444444;
                    line-height: 0.533333rem;
                }
            }
            .empty-border {
                margin-top: 0.373333rem;
                width: 0.933333rem;
                height: 0.053333rem;
                background: rgba(240, 187, 27, 1);
                border-radius: 0.053333rem;
                opacity: 0.5647;
            }
        }
        .order-number {
            margin-top: 1.066667rem;
            font-size: 0.373333rem;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: #444444;
            line-height: 0.533333rem;
            .order-title {
                margin-right: 0.373333rem;
            }
        }
    }

    .order-card {
        margin-top: 0.666667rem;
        // padding: 0.4rem 0.533333rem 0 0.533333rem;
        background: $white;
        .each-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 0.4rem;
            &.title {
                font-size: 0.426667rem;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #444444;
                line-height: 0.586667rem;
            }
            .left {
                color: $grey4;
                font-size: 14px;
                width: 30%;
                &.black {
                    color: #333333;
                }
            }
            .right {
                font-size: 14px;
                color: #333333;
                width: 70%;
                text-align: right;
                .right-icon {
                    margin-left: 0.186667rem;
                    width: 0.16rem;
                    height: 0.266667rem;
                }
                .price {
                    color: $orange;
                    font-size: 14px;
                }
                .form-input /deep/ {
                    padding: 0px;
                    min-width: 170px;
                    input.van-field__control {
                        text-align: right;
                    }
                }
            }
        }
        .goods-preview {
            padding-top: 0.4rem;
            padding-bottom: 0.533333rem;
            display: flex;
            .preview {
                margin-right: 0.266667rem;
                width: 1.813333rem;
                height: 1.813333rem;
                border-radius: 5px;
            }
            .detail-wra {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .row1 {
                    font-size: 0.48rem;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                    color: #444444;
                    line-height: 0.666667rem;
                }
                .row2 {
                    margin-top: 0.533333rem;
                    font-size: 0.426667rem;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: #8c8c8c;
                    line-height: 0.586667rem;
                    .mr25 {
                        color: #444444;
                        margin-left: 0.533333rem;
                    }
                }
                .row3 {
                    margin-top: 0.533333rem;
                    font-size: 0.426667rem;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: #8c8c8c;
                    line-height: 0.586667rem;
                    .buy-number {
                        color: #444444;
                        margin-left: 0.533333rem;
                        span {
                            font-size: 12px;
                        }
                        .multiplication {
                            font-size: 20px;
                        }
                    }
                }
            }
        }
        .each-block {
            background: $white;
            .each-row {
                display: flex;
                align-items: center;
                &:last-child {
                    margin-bottom: 0px;
                }
                .left {
                    color: #444444;
                    font-size: 0.426667rem;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                    line-height: 0.586667rem;
                }
                .right {
                    font-size: 16px;
                    .price {
                        color: #444444;
                        font-size: 16px;
                        font-weight: bold;
                    }
                    .form-input /deep/ {
                        padding: 0px;
                        min-width: 170px;
                        input.van-field__control {
                            color: #444444;
                            font-size: 16px;
                        }
                    }
                }
            }
            .radios /deep/ {
                .van-radio__input {
                    font-size: 16px;
                }
                .van-radio {
                    padding: 0.333333rem 0;
                    .van-icon-checked {
                        color: #f0bb1b;
                    }
                    .van-radio__label {
                        color: #444444;
                        font-size: 0.426667rem;
                        font-family: PingFangSC-Semibold;
                        line-height: 0.586667rem;
                    }
                }
            }
            .reason-textarea-warapper {
                position: relative;
                margin: 0.053333rem 0 0.533333rem;
                .reason-textarea {
                    width: 8.933333rem;
                    height: 3.2rem;
                    border-radius: 0.16rem;
                    border: 1px solid rgba(158, 158, 158, 0.25);
                    &.van-field {
                        align-items: flex-start;
                        font-size: 0.373333rem;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        color: #8c8c8c;
                        line-height: 0.533333rem;
                        .van-field__body {
                            textarea::-webkit-input-placeholder {
                                font-size: 0.373333rem;
                                font-family: PingFangSC-Regular;
                                font-weight: 400;
                                color: #8c8c8c;
                                line-height: 0.533333rem;
                            }
                        }
                    }
                }
                .text-length {
                    position: absolute;
                    bottom: 0.16rem;
                    right: 0.2rem;
                    font-size: 0.373333rem;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: #8c8c8c;
                    line-height: 0.533333rem;
                }
            }
            .mb35 {
                margin-bottom: 0.466667rem;
            }
            .submit-btn {
                width: 9.2rem;
                height: 1.2rem;
                border-radius: 0.6rem;
                background: linear-gradient(
                    90deg,
                    rgba(248, 199, 64, 1) 0%,
                    rgba(245, 149, 38, 1) 100%
                );
                box-shadow: 0 0 15px 0px rgba(248, 199, 64, 0.49);
                // position: fixed;
                // bottom: 0.56rem;
                // left: 0;
                // right: 0;
                margin: auto;
                color: $white;
                font-size: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
</style>
